const pendingXeroSyncs = new Map();
let pollTimer = null;
let pollStartedAt = null;
const POLL_INTERVAL = 3000;
const POLL_TIMEOUT = 60000;

function startPolling() {
  if (pollTimer) return;
  pollStartedAt = Date.now();
  pollTimer = setInterval(pollSyncStatus, POLL_INTERVAL);
}

function stopPolling() {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
    pollStartedAt = null;
  }
}

async function pollSyncStatus() {
  if (pendingXeroSyncs.size === 0) {
    stopPolling();
    return;
  }

  if (Date.now() - pollStartedAt > POLL_TIMEOUT) {
    stopPolling();
    for (const [key, button] of pendingXeroSyncs) {
      restoreSyncButton(button, key);
    }
    pendingXeroSyncs.clear();
    return;
  }

  const items = [];
  for (const [key] of pendingXeroSyncs) {
    const [type, id] = key.split(":");
    items.push({ type, id: parseInt(id) });
  }

  try {
    const response = await useFetch(route("api.xero.sync-status"), {
      method: "POST",
      body: JSON.stringify({ items }),
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) return;

    const data = await response.json();

    for (const item of data.items) {
      const key = `${item.type}:${item.id}`;
      const button = pendingXeroSyncs.get(key);
      if (!button) continue;

      if (!item.pending && item.xero_url) {
        button.outerHTML = `<a class="btn btn-sm btn-info" href="${item.xero_url}" target="_blank" rel="noopener noreferrer"><i class="fa fa-fw fa-external-link-alt"></i> Xero</a>`;
        pendingXeroSyncs.delete(key);
      } else if (!item.pending && !item.xero_url) {
        restoreSyncButton(button, key);
        pendingXeroSyncs.delete(key);
      }
    }

    if (pendingXeroSyncs.size === 0) {
      stopPolling();
    }
  } catch {
    // Silently retry on next interval.
  }
}

function restoreSyncButton(button, key) {
  const [type, id] = key.split(":");
  button.disabled = false;
  button.className = "btn btn-sm btn-warning";
  button.setAttribute("onclick", `window.syncToXero(this, '${type}', ${id})`);
  button.innerHTML = '<i class="fa fa-fw fa-sync"></i> Sync to Xero';
}

function setPendingState(button) {
  button.disabled = true;
  button.className = "btn btn-sm btn-secondary";
  button.removeAttribute("onclick");
  button.innerHTML = '<i class="fa fa-fw fa-spinner fa-spin"></i> Syncing...';
}

window.syncToXero = async function (button, type, id) {
  const key = `${type}:${id}`;
  setPendingState(button);

  try {
    const response = await useFetch(route("api.xero.sync", { type, id }), {
      method: "POST",
    });

    const data = await response.json();

    if (response.ok) {
      pendingXeroSyncs.set(key, button);
      startPolling();
    } else {
      throw new Error(data.message || "Sync failed");
    }
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "Sync Failed",
      text: e.message,
    });
    restoreSyncButton(button, key);
  }
};

function initPendingButtons() {
  const buttons = document.querySelectorAll("[data-xero-pending]");
  for (const button of buttons) {
    const type = button.getAttribute("data-xero-type");
    const id = button.getAttribute("data-xero-id");
    if (type && id) {
      pendingXeroSyncs.set(`${type}:${id}`, button);
    }
  }
  if (pendingXeroSyncs.size > 0) {
    startPolling();
  }
}

// Watch for datatable async rendering that may add pending buttons after initial load
const observer = new MutationObserver(() => {
  const buttons = document.querySelectorAll("[data-xero-pending]");
  for (const button of buttons) {
    const type = button.getAttribute("data-xero-type");
    const id = button.getAttribute("data-xero-id");
    const key = `${type}:${id}`;
    if (type && id && !pendingXeroSyncs.has(key)) {
      pendingXeroSyncs.set(key, button);
    }
  }
  if (pendingXeroSyncs.size > 0) {
    startPolling();
  }
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initPendingButtons();
    observer.observe(document.body, { childList: true, subtree: true });
  });
} else {
  initPendingButtons();
  observer.observe(document.body, { childList: true, subtree: true });
}
